import { navigateTo } from '#imports';

export const legacyHubCategoryFilter = defineNuxtRouteMiddleware((to) => {
  const { categoryId, ...query } = to.query;

  if (categoryId === undefined) {
    return;
  }

  return navigateTo(
    {
      path: to.path,
      query: query.categoryIds ? query : { ...query, categoryIds: categoryId },
      hash: to.hash,
    },
    { replace: true, redirectCode: 302 },
  );
});
